import { db } from '../firebase';
import { getBackendError } from 'common/utils';

const userMapper = (documentSnapshot) => {
  const { dateModified, dateCreated, deviceToken, displayName, email, language, nameFirst, nameLast, photoURL, emailProvider, cntPushNotification } = documentSnapshot.data();

  let dateModifiedLocal = dateModified ? new Date(dateModified.seconds * 1000).toLocaleString('ru-RU') : '-';
  dateModifiedLocal = dateModifiedLocal.substring(0, dateModifiedLocal.length - 3);
  let dateCreatedLocal = dateCreated ? new Date(dateCreated.seconds * 1000).toLocaleString('ru-RU') : '-';
  dateCreatedLocal = dateCreatedLocal.substring(0, dateCreatedLocal.length - 3);
  return {
    uid: documentSnapshot.id,
    dateCreated: dateCreatedLocal,
    dateModified: dateModifiedLocal,
    deviceToken: deviceToken ? deviceToken : '-',
    displayName,
    email,
    emailProvider: emailProvider ? emailProvider : '-',
    language: language.uid,
    nameFirst,
    nameLast,
    photoURL,
    cntPushNotification: cntPushNotification ? cntPushNotification : 0,
  };
};

const userListMapper = (docs) => {
  return docs.map((documentSnapshot) => userMapper(documentSnapshot));
};

export const getUsersList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      //.orderBy('dateModified')
      .get()
      .then((querySnapshot) => resolve(userListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getUserItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .get()
      .then((querySnapshot) => {
        const { uid, dateModified, dateCreated, deviceToken, displayName, email, language, nameFirst, nameLast, photoURL, emailProvider, isShow } = querySnapshot.data();
        let dateModifiedLocal = dateModified ? new Date(dateModified.seconds * 1000).toLocaleString('ru-RU') : '-';
        dateModifiedLocal = dateModifiedLocal.substring(0, dateModifiedLocal.length - 3);
        let dateCreatedLocal = dateCreated ? new Date(dateCreated.seconds * 1000).toLocaleString('ru-RU') : '-';
        dateCreatedLocal = dateCreatedLocal.substring(0, dateCreatedLocal.length - 3);
        const obj = {
          uid,
          dateCreated: dateCreatedLocal,
          dateModified: dateModifiedLocal,
          deviceToken: deviceToken ? deviceToken : '-',
          displayName,
          email,
          emailProvider: emailProvider ? emailProvider : '-',
          language: language.uid,
          nameFirst,
          nameLast,
          photoURL,
          isShow,
        };
        
        resolve(obj);
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserImage = (id, image) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        photoURL: image,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserDisplayName = (id, displayName) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        displayName,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserEmail = (id, email) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        email,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserFirstName = (id, firstName) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        nameFirst: firstName,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserLastName = (id, lastName) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        nameLast: lastName,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateUserIsShow = (id, isShow) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        isShow: isShow === 'true' ? true : false,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateCntPushNotification = (id, cntPushNotification) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        cntPushNotification,
        dateModified: new Date()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};